// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__Jk0bm","boxTitle":"Qualiphy_boxTitle__51JHI","box":"Qualiphy_box__2tEYx","toggleWrap":"Qualiphy_toggleWrap__3SZke"};